
import React, { useState } from 'react';
import Button from "@material-ui/core/Button";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { styled } from '@material-ui/core/styles';


const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});


export default function UploadFileButton({name, label, patch}) {
  const [loading, setLoading] = useState(false)

  const uploadFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLoading(true)

      const config = {
        headers: {'Content-Type': 'multipart/form-data'}
      };

      let fd = new FormData();
      fd.append(name, file);

      patch(fd, config).finally(() => setLoading(false));
    }
  };

  return (
    <Button
      component="label"
      role={undefined}
      variant="outlined"
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
      disabled={loading}
    >
      {label}
      <VisuallyHiddenInput type="file" onChange={uploadFile} accept="image/png, image/jpeg" />
    </Button>
  )
}
